import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { Role, UsersListParams } from '@/types/auth'
import {
	deleteUser,
	getUsers,
	resetUserPassword,
	updateUserRole,
	updateUserStatus,
} from '../services/users'

const USERS_KEY = ['users']

export function useUsers(params?: UsersListParams) {
	return useQuery({
		queryKey: [...USERS_KEY, params],
		queryFn: () => getUsers(params),
		staleTime: 5 * 60 * 1000,
	})
}

export function useUpdateUserRole() {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: ({ id, role }: { id: string; role: Role }) =>
			updateUserRole(id, { role }),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: USERS_KEY })
		},
	})
}

export function useUpdateUserStatus() {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: ({ id, isActive }: { id: string; isActive: boolean }) =>
			updateUserStatus(id, { isActive }),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: USERS_KEY })
		},
	})
}

export function useResetUserPassword() {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: (id: string) => resetUserPassword(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: USERS_KEY })
		},
	})
}

export function useDeleteUser() {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: (id: string) => deleteUser(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: USERS_KEY })
		},
	})
}
